export const getaAssetPath = (file) => `https://d2lhmk0wz60r3x.cloudfront.net/assets/${file}`;
